import imageCompression from 'browser-image-compression';

// Image compression using browser-image-compression
const compressImage = async (file) => {

  const options = {
    maxSizeMB: 0.1, // Maximum file size (100 kB)
    maxWidthOrHeight: 100, // Maximum width or height
    useWebWorker: true, // Use WebWorker for performance
  };

  try {
    const compressedFile = await imageCompression(file, options);
    return URL.createObjectURL(compressedFile);

  } catch (error) {
    console.error('Error compressing image:', error);
  };

};

export default compressImage;